import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";
import { createSearchParameters } from "@/helpers/SearchHelper.js";

export {
  GetAllContracts,
  GetAllContractsNoVersions,
  GetPositionInTopGav,
  GetTopGavs,
  SaveTopGavs,
  GetVersionInformation,
  SaveVersionInformation,
  CreateNewContract,
  CreateNewContractVersion,
  CreateNewContractVersionFromCopy,
  DeleteContractVersion,
  GetContractInformation,
  SaveContractInformation,
  GetAllContractVersions,
  GetContractTypes,
  GetVersionStatus,
  GetAnhang1Status,
  GetAveStatus,
  AddNewComment,
  DeleteComment,
  UpdateComment,
  GetContractTags,
  GetVersionTags,
  GetAllContractResponsiblity,
  CreateNewContractResponsiblity,
  SaveContractResponsiblity,
  DeleteContractResponsiblity,
  GetSupplementaryContractEditions,
  GetContractResponsiblityTags,
  GetAvailableSupplementaryContracts,
  GetSupplementaryContracts,
  DeleteSupplementaryContracts,
  PostSupplementaryContracts,
  GetMainContracts,
  GetVersionResponsables,
  GetContractResponsables,
  GetCriteriaStructurelist,
};

function GetVersionResponsables(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        "/contractversionssearch/versionresponsables",
      headers,
    )
    .then((response) => {
      if (response.data) {
        onSuccess(response.data);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function GetContractResponsables(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        "/contractversionssearch/contractresponsables",
      headers,
    )
    .then((response) => {
      if (response.data) {
        onSuccess(response.data);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function GetAvailableSupplementaryContracts(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(process.env.VUE_APP_BASE_API_URL + "/supplementarycontracts", headers)
    .then((response) => {
      if (response.data) {
        onSuccess(response.data);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function GetCriteriaStructurelist(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        "/contractversionssearch/criteriastructurelist",
      headers,
    )
    .then((response) => {
      if (response.data) {
        onSuccess(response.data);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function GetSupplementaryContracts(contractNumber, onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        "/contracts/" +
        contractNumber +
        "/supplementarycontracts",
      headers,
    )
    .then((response) => {
      if (response.data) {
        onSuccess(response.data);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function GetMainContracts(contractNumber, onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        "/supplementarycontracts/" +
        contractNumber +
        "/contracts",
      headers,
    )
    .then((response) => {
      if (response.data) {
        onSuccess(response.data);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function PostSupplementaryContracts(
  contractNumber,
  supplementaryContractNumber,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        "/contracts/" +
        contractNumber +
        "/supplementarycontracts/" +
        supplementaryContractNumber,
      null,
      headers,
    )
    .then((response) => {
      if (response.data) {
        onSuccess(response.data);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function DeleteSupplementaryContracts(
  contractNumber,
  supplementaryContractNumber,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();
  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL +
        "/contracts/" +
        contractNumber +
        "/supplementarycontracts/" +
        supplementaryContractNumber,
      headers,
    )
    .then((response) => {
      if (response.data) {
        onSuccess(response.data);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function GetSupplementaryContractEditions(contractNumber, onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        "/contracts/" +
        contractNumber +
        "/supplementaryContracts/editions",
      headers,
    )
    .then((response) => {
      if (response.data) {
        onSuccess(response.data);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function GetContractResponsiblityTags(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + "/tag/contractresponsibletypes",
      headers,
    )
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function GetAllContractResponsiblity(contractId, onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        "/contracts/" +
        contractId +
        "/contractresponsibles",
      headers,
    )
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        if (response.data) {
          onSuccess(response.data);
        }
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function CreateNewContractResponsiblity(
  contractId,
  contractresponsibleObject,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();
  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        "/contracts/" +
        contractId +
        "/contractresponsibles",
      contractresponsibleObject,
      headers,
    )
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function SaveContractResponsiblity(
  contractId,
  contractresponsibleObject,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        "/contracts/" +
        contractId +
        "/contractresponsibles",
      contractresponsibleObject,
      headers,
    )
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function DeleteContractResponsiblity(
  contractId,
  contractresponsibleId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();
  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL +
        "/contracts/" +
        contractId +
        "/contractresponsibles/" +
        contractresponsibleId,
      headers,
    )
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function GetAllContracts(requestData, onSuccess, onError) {
  var parameters = createSearchParameters(requestData);
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        "/contractversionssearch?" +
        parameters,
      headers,
    )
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function GetAllContractsNoVersions(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + "/contracts", headers)
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function GetAllContractVersions(contractId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions`,
      headers,
    )
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function SaveVersionInformation(
  versionInformation,
  contractId,
  versionId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}`,
      versionInformation,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function CreateNewContractVersionFromCopy(
  contractId,
  versionId,
  editionId,
  CopyMindestlohn,
  importData,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  var cloneRequestObject = {
    versionId: versionId,
    editionId: editionId,
    copyMindestlohn: CopyMindestlohn,
    sourceData: importData,
  };

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/clone`,
      cloneRequestObject,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function CreateNewContract(
  contractNumber,
  firstContractConclusion,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  var newContractObject = {
    ContractNumber: contractNumber,
    ContractName: "Neuer Vertrag",
    ContractLanguage: "de-CH",
    FirstContractConclusion: firstContractConclusion,
  };

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL + `/contracts`,
      newContractObject,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function CreateNewContractVersion(contractId, onSuccess, onError) {
  var headers = getAuthHeader();

  // We create an empty Version.
  var newVersionRequestObject = {
    id: 0,
    number: 0,
    validFrom: "",
    validTo: "",
    secoId: "",
    isInternalOnly: true,
    contractId: 0,
    infoId: 0,
    versionContents: [
      {
        id: 0,
        versionId: 0,
        value: "",
        nameShort: "",
        language: "de-CH",
      },
    ],
    translatedToLanguages: [
      {
        language: "de-CH",
      },
    ],
  };

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions`,
      newVersionRequestObject,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function DeleteContractVersion(contractId, versionId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}`,
      headers,
    )
    .then(() => {
      onSuccess();
    })
    .catch((error) => {
      onError(error);
    });
}

function GetVersionInformation(contractId, versionId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function SaveContractInformation(
  contractInformation,
  contractNumber,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL + `/contracts/${contractNumber}`,
      contractInformation,
      headers,
    )
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response.data);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function GetContractInformation(contractNumber, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + `/contracts/${contractNumber}`,
      headers,
    )
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response.data);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function GetPositionInTopGav(contractId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/topposition`,
      headers,
    )
    .then((response) => {
      if (response.status == 204) {
        onSuccess(null);
      } else {
        onSuccess(response.data);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function GetTopGavs(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + "/topcontracts", headers)
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function SaveTopGavs(data, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .put(process.env.VUE_APP_BASE_API_URL + "/topcontracts", data, headers)
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function GetContractTypes(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + "/contracttypes", headers)
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function GetVersionStatus(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + "/enumlist/versionstate", headers)
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function GetAveStatus(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + "/enumlist/avestate", headers)
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function GetAnhang1Status(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + "/enumlist/anhang1state", headers)
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function AddNewComment(commentObject, contractId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/comments`,
      commentObject,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function DeleteComment(contractId, commentId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/comments/${commentId}`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function UpdateComment(commentObject, contractId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/comments`,
      commentObject,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function GetContractTags(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + `/tag/contracttags`, headers)
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function GetVersionTags(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + `/tag/versiontags`, headers)
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response);
      }
    })
    .catch((error) => {
      onError(error);
    });
}
